import React from "react"
import { RenderParallaxSection } from "./utils"

const MorphicParallax = props => {
  return <>{RenderParallaxSection(props)}</>
}

export default MorphicParallax
